import $ from 'jquery'
import _ from 'underscore'
import StateManager from '../scuba/StateManager'

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  $(node)
    .find('.js-image-hover')
    .each(function(i, el) {
      new ImageHover(el)
    })
})

/* --------------------------------------------------
    CLASS
-------------------------------------------------- */

class ImageHover {
  constructor(el) {
    const self = this
    self.uid = _.uniqueId('scuba-')
    self.$el = $(el)
    self.$image = self.$el.find('.js-image-hover__image').first()

    self.$el.on('mouseover', '[data-hover-image]', e => {
      const currentImg = $(e.currentTarget).attr('data-hover-image')
      const url =
        typeof currentImg !== 'undefined' && currentImg !== ''
          ? currentImg
          : self.$image.attr('data-default')
      if (typeof url !== 'undefined') {
        self.$image.html(`<img src="${url}"/>`)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/components/ImageHover.js